if (!customElements.get('register-installer-interest')) {
  customElements.define('register-installer-interest', class RegisterInstallerInterest extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      this.isInterestAdded = false;
      this.cartAttributes = {};
      this.buttonAddState = this.dataset.buttonCopyAdd;
      this.buttonAddedState = this.dataset.buttonCopyAdded;
    }


    connectedCallback() {
      this.button.addEventListener('click', this.onSubmitHandler.bind(this));
      this.checkIfInstallerAdded();
    }

    onSubmitHandler() {
        if(!this.isInterestAdded) {
          this.addInterestToCart();
        } else {
          this.removeInterestFromCart();
        }
    }

    async getCartAttributes() {
      await fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(data => {
        this.cartAttributes = data.attributes;
      });
    }

    async addInterestToCart() {
      this.button.disabled = true;
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Recommended Installer': 'true'
          }
        })
      })
      .then(res => res.json())
      .then(data => {
        if(data.attributes['Recommended Installer'] === 'true') {
          this.button.innerHTML = this.buttonAddedState;
          this.isInterestAdded = true;
        }
      })
      this.button.disabled = false;
    }

    async removeInterestFromCart() {
      this.button.disabled = true;
      await this.getCartAttributes();

      if(this.cartAttributes['Recommended Installer']) {
        this.cartAttributes['Recommended Installer'] = '';
      }
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: this.cartAttributes
        })
      })
      .then(res => res.json())
      .then(data => {
        if(!data.attributes['Recommended Installer']) {
          this.button.innerHTML = this.buttonAddState;
          this.isInterestAdded = false;
        }
      });
      this.button.disabled = false;
    }

    async checkIfInstallerAdded() {
      await fetch(`${window.Shopify.routes.root}cart.js`)
      .then(res => res.json())
      .then(data => {
        if (data.attributes['Recommended Installer']) {
          if( data.attributes['Recommended Installer'] === 'true') {
            this.isInterestAdded = true;
            this.button.innerHTML = this.buttonAddedState;
          } else {
            this.isInterestAdded = false;
            this.button.innerHTML = this.buttonAddState;
          }
        }
      });
    }
  });
}